import { forEach } from './array-utils';
import { isMobile } from './device-utils';
import { isLandscape } from './mediaquery-utils';

const addZIndexAuto = (selector) => {
  const elements = document.querySelectorAll(`.${selector}`);
  forEach((element) => {
    element.classList.add('u-z-index-auto');
  })(elements);
};

const removeZIndexAuto = (selector) => {
  const elements = document.querySelectorAll(`.${selector}`);
  forEach((element) => {
    element.classList.remove('u-z-index-auto');
  })(elements);
};

const enabler = {
  MOBILE_PORTRAIT: (selector) => (isMobile() && !isLandscape() ? addZIndexAuto(selector) : null),
};

const disabler = {
  MOBILE_PORTRAIT: (selector) => (isMobile() && !isLandscape() ? removeZIndexAuto(selector) : null),
};

/**
 * Set z-index auto
 * @param {String} selector It does not need to begin with the dot.
 * Example: 'my-selector' --> RIGHT  //  '.my-selector' --> WRONG
 */
export const setZIndexAuto = (selector, breakpoint) => enabler[breakpoint](selector);

/**
 * Unset z-index auto
 * @param {String} selector It does not need to begin with the dot.
 * Example: 'my-selector' --> RIGHT  //  '.my-selector' --> WRONG
 */
export const unsetZIndexAuto = (selector, breakpoint) => disabler[breakpoint](selector);
